module.exports = __webpack_public_path__ + "assets/img/workspace_13.73355b01.jpg";